// HubspotTracking.js
import { useEffect } from 'react';

const HubspotTracking = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    // script.src = '//js-na2.hs-scripts.com/242306328.js'; // Replace YOUR_HUBSPOT_ID
    script.src = '//js-na2.hs-scripts.com/242306328.js?businessUnitId=46161778';
    document.body.appendChild(script);

    // Clean up the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null; // This component doesn't render anything visible
};

export default HubspotTracking;
